import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserMenuComponent } from './user-menu.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';

import { ChangePhonenumberDialogModule } from '@fleet/auth/components/change-phonenumber-dialog/change-phonenumber-dialog.module';
import { ChangeUsernameDialogModule } from '@fleet/auth/components/change-username-dialog/change-username-dialog.module';
import { ChangePasswordModule } from '../change-password';
import { ChangeMfaDialogComponent } from '@fleet/auth/components/change-mfa-dialog/change-mfa-dialog.component';

@NgModule({
  declarations: [UserMenuComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatDialogModule,
    ReactiveFormsModule,
    ChangePasswordModule,
    ChangePhonenumberDialogModule,
    ChangeUsernameDialogModule,
    ChangeMfaDialogComponent,
  ],
  exports: [UserMenuComponent],
})
export class UserMenuModule {}
